import { lastPathGuard } from '../guards/lastPathGuard';

export default [
    {
        path: '/type-professionals',
        name: 'typeProfessionalsList',
        component: () => import(/* webpackChunkName: "professionals" */ '../views/typeProfessionals/List.vue')
    },
    {
        path: '/type-professionals/create',
        name: 'typeProfessionalsCreate',
        component: () => import(/* webpackChunkName: "professionals" */ '../views/typeProfessionals/Form.vue')
    },
    {
        path: '/type-professionals/:id/edit',
        name: 'typeProfessionalsEdit',
        component: () => import(/* webpackChunkName: "professionals" */ '../views/typeProfessionals/Form.vue')
    },
    {
        path: '/professionals',
        name: 'professionalsList',
        component: () => import(/* webpackChunkName: "professionals" */ '../views/professionals/List.vue')
    },
    {
        path: '/professionals/create',
        name: 'professionalsCreate',
        component: () => import(/* webpackChunkName: "professionals" */ '../views/professionals/Form.vue')
    },
    {
        path: '/professionals/:id/edit',
        name: 'professionalsEdit',
        component: () => import(/* webpackChunkName: "professionals" */ '../views/professionals/Form.vue'),
        beforeEnter: lastPathGuard
    },
    {
        path: '/users',
        name: 'usersList',
        component: () => import('../views/users/List.vue')
    },
    {
        path: '/users/create',
        name: 'usersCreate',
        component: () => import('../views/users/Form.vue')
    },
    {
        path: '/users/:id/edit',
        name: 'usersEdit',
        component: () => import('../views/users/Form.vue')
    },
    {
        path: '/profile',
        name: 'profileEdit',
        component: () => import(/* webpackChunkName: "professionals" */'../views/Profile.vue')
    },
    {
        path: '/change-password',
        name: 'passwordChange',
        component: () => import(/* webpackChunkName: "professionals" */'../views/Password.vue')
    },
]